/**
 * Stripe Provider
 * Wraps the app with Stripe Elements context
 */

import { ReactNode } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Initialize Stripe outside of component to avoid recreating on each render
const stripePromise = stripePublishableKey 
  ? loadStripe(stripePublishableKey)
  : null;

interface StripeProviderProps {
  children: ReactNode;
}

export function StripeProvider({ children }: StripeProviderProps) {
  if (!stripePromise) {
    // If no Stripe key, just render children without Stripe context
    // This allows the app to work in development without Stripe configured
    return <>{children}</>;
  }

  return (
    <Elements 
      stripe={stripePromise}
      options={{
        appearance: {
          theme: 'stripe',
          variables: {
            colorPrimary: '#0a2540', // navy
            colorBackground: '#ffffff',
            colorText: '#0a2540',
            colorDanger: '#df1b41',
            fontFamily: 'Inter, system-ui, sans-serif',
            borderRadius: '8px',
          },
        },
      }}
    >
      {children}
    </Elements>
  );
}

export { stripePromise };
